// extracted by mini-css-extract-plugin
module.exports = {"component":"carousel-navigation_component__js5MW"};